import { createI18n } from 'vue-i18n'

import usersRepository from '@/api/usersRepository.ts';
import { useUserStore } from '@/stores/user'

type LocaleMessage = string | LocaleMessageTree | LocaleMessage[]
type LocaleMessageTree = Record<string, LocaleMessage>

const normalizeInterpolationPlaceholders = (message: LocaleMessage): LocaleMessage => {
  if (typeof message === 'string') {
    return message
      .replace(/%\{([a-zA-Z0-9_]+)\}/g, '{$1}')
      .replace(/%<([a-zA-Z0-9_]+)>[a-z]/g, '{$1}')
  }

  if (Array.isArray(message)) {
    return message.map(normalizeInterpolationPlaceholders)
  }

  return Object.fromEntries(
    Object.entries(message).map(([key, value]) => [key, normalizeInterpolationPlaceholders(value)])
  )
}

type MessageSchema = LocaleMessageTree

export const i18nConfig = createI18n<[MessageSchema], string>({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
})

export const setupI18n = async () => {
  const userStore = useUserStore()
  const locales = await usersRepository.getUserLocales();
  const normalizedLocales = normalizeInterpolationPlaceholders(locales) as MessageSchema
  const localeCode = userStore.currentUser.locale;

  i18nConfig.global.locale.value = localeCode
  i18nConfig.global.setLocaleMessage(localeCode, normalizedLocales)

  return i18nConfig
}
